import React from 'react';

import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';

import ViewAllChangeLogs from '../ViewAllChangeLogs';
import ChangeLogsDetails from '../ChangeLogsDetails';
import constant from '../../../constant.json';

const { CHANGE_LOGS_TABS } = constant;

/**
 * @name ChangeLogTabs
 * @description Component for managing tab navigation between "All Change Logs" and "View Details".
 * It uses TabContext to handle the current active tab and manages the state of change details.
 * @returns {JSX.Element} - The rendered component.
 */
const ChangeLogTabs = ({ currentSelectedChange, updateCurrentSelectedChange, filteredAllChangeLogs }) => {

    let tab = currentSelectedChange ? CHANGE_LOGS_TABS.CHANGE_LOGS_DETAILS : CHANGE_LOGS_TABS.VIEW_ALL_CHANGE_LOGS;

    return (

        <TabContext value={tab} >
            <TabPanel sx={{ padding: "0rem" }} value={CHANGE_LOGS_TABS.VIEW_ALL_CHANGE_LOGS} >
                <ViewAllChangeLogs
                    filteredAllChangeLogs={filteredAllChangeLogs}
                    updateCurrentSelectedChange={updateCurrentSelectedChange}
                />
            </TabPanel>
            <TabPanel sx={{ padding: "0rem" }} value={CHANGE_LOGS_TABS.CHANGE_LOGS_DETAILS} >
                <ChangeLogsDetails
                    updateCurrentSelectedChange={updateCurrentSelectedChange}
                    currentSelectedChange={currentSelectedChange} />
            </TabPanel>
        </TabContext>

    );
};

export default ChangeLogTabs;
